export const BIT = 1;
export const KB = BIT * 1024;
export const MB = KB * 1024;
